// EHC's own web page (ADR 0021): its sign-in page (its name, icon and colour; its identity provider) and the
// app full-bleed, with no companions over it. No bar, no host
// chrome: who is signed in, About and Sign out are the app's own UI (its account menu).
import '@cortex/app-shell/csp-nonce';
import { mountApp } from '@cortex/app-shell';
import './styles.css';

// No speed dial: the Close Room is the whole page (the app pins only governance, for its data rules).
void mountApp([]);
